const localhost = window.location.origin === 'https://localhost:4004';
// const gep = 0 <= window.location.origin.indexOf('gep.nbware.co.kr');
// const HOST_API = localhost ? 'https://gep.nbware.co.kr:9143' : gep ? `https://${window.location.hostname}:9143` : `https://${window.location.hostname}:9443`;
const HOST_API = localhost ? 'https://www.ddpartner.co.kr:8446' : `https://${window.location.hostname}:8446`;
export default HOST_API;
